// extracted by mini-css-extract-plugin
export default {"Container":"ChatList_Container__6Ixjc","List":"ChatList_List__Uwd1i","loading":"ChatList_loading__874Yb","no_messages":"ChatList_no_messages__h+De-"};